var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconfeatherEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17.219,
    viewBox: "0 0 21 17.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_35",
    "data-name": "Union 35",
    d: "M2.938,17.219A2.938,2.938,0,0,1,0,14.28V3a1.212,1.212,0,0,1,0-.137A2.941,2.941,0,0,1,2.938,0H18.064A2.939,2.939,0,0,1,21,2.905V14.28a2.938,2.938,0,0,1-2.936,2.939ZM2.1,14.28a.838.838,0,0,0,.841.843H18.064a.84.84,0,0,0,.841-.843V4.946L11.1,10.41a1.009,1.009,0,0,1-.595.194A1.052,1.052,0,0,1,9.9,10.41L2.1,4.946Zm8.4-6,8.27-5.795a.841.841,0,0,0-.709-.385H2.938a.834.834,0,0,0-.709.385Z",
    transform: "translate(0 0)",
    fill: "#4e4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherEmail);
export default __webpack_public_path__ + "static/media/Icon feather-email.72bf5a7bb442966169837ad61c9cc746.svg";
export { ForwardRef as ReactComponent };